// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { VersionableFragmentDoc } from '../../../../components/ReadyPlanVersionHeader.generated';
import { PotentialOperationDetailsFragmentDoc } from '../../../../queries/fragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PromoteToCheckoutStateQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type PromoteToCheckoutStateQuery = { __typename?: 'Query', productOffering: { __typename?: 'ProductOffering', id: string, effectiveStatus: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus }, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined } | null | undefined, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } }>, canPublishToUnderwriting: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }, readyPlanAggregateVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, canPromote: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } };

export type PromoteToCheckout_PromoteMutationVariables = Types.Exact<{
  input: Types.PromoteToCheckoutInput;
}>;


export type PromoteToCheckout_PromoteMutation = { __typename?: 'Mutation', promoteToCheckout: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type PromoteToCheckout_RestoreMutationVariables = Types.Exact<{
  input: Types.SaveProductOfferingInput;
}>;


export type PromoteToCheckout_RestoreMutation = { __typename?: 'Mutation', saveProductOffering: { __typename?: 'SaveProductOfferingResult', productOffering: { __typename?: 'ProductOffering', id: string } } };

export type UsePromoteToCheckout_ProductOfferingFragment = { __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus }, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined };

export type UsePromoteToCheckout_VersionFragment = { __typename?: 'ReadyPlanAggregateVersion', id: string, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, canPromote: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export const UsePromoteToCheckout_ProductOfferingFragmentDoc = gql`
    fragment UsePromoteToCheckout_ProductOffering on ProductOffering {
  id
  status {
    code
  }
  aggregateCheckout {
    id
  }
}
    `;
export const UsePromoteToCheckout_VersionFragmentDoc = gql`
    fragment UsePromoteToCheckout_Version on ReadyPlanAggregateVersion {
  id
  promotedAt
  canPromote {
    ...PotentialOperationDetails
  }
}
    ${PotentialOperationDetailsFragmentDoc}`;
export const PromoteToCheckoutStateDocument = gql`
    query PromoteToCheckoutState($id: ID!, $versionId: ID!) {
  productOffering(id: $id, versionId: $versionId) {
    ...UsePromoteToCheckout_ProductOffering
    effectiveStatus {
      code
    }
    aggregateCheckout {
      id
      displayVersion
      promotedAt
    }
    aggregateVersions {
      ...Versionable
    }
    canPublishToUnderwriting {
      ...PotentialOperationDetails
    }
  }
  readyPlanAggregateVersion(id: $versionId) {
    ...UsePromoteToCheckout_Version
  }
}
    ${UsePromoteToCheckout_ProductOfferingFragmentDoc}
${VersionableFragmentDoc}
${PotentialOperationDetailsFragmentDoc}
${UsePromoteToCheckout_VersionFragmentDoc}`;

/**
 * __usePromoteToCheckoutStateQuery__
 *
 * To run a query within a React component, call `usePromoteToCheckoutStateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoteToCheckoutStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoteToCheckoutStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function usePromoteToCheckoutStateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PromoteToCheckoutStateQuery, PromoteToCheckoutStateQueryVariables> & ({ variables: PromoteToCheckoutStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PromoteToCheckoutStateQuery, PromoteToCheckoutStateQueryVariables>(PromoteToCheckoutStateDocument, options);
      }
export function usePromoteToCheckoutStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PromoteToCheckoutStateQuery, PromoteToCheckoutStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PromoteToCheckoutStateQuery, PromoteToCheckoutStateQueryVariables>(PromoteToCheckoutStateDocument, options);
        }
// @ts-ignore
export function usePromoteToCheckoutStateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PromoteToCheckoutStateQuery, PromoteToCheckoutStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PromoteToCheckoutStateQuery, PromoteToCheckoutStateQueryVariables>;
export function usePromoteToCheckoutStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PromoteToCheckoutStateQuery, PromoteToCheckoutStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PromoteToCheckoutStateQuery | undefined, PromoteToCheckoutStateQueryVariables>;
export function usePromoteToCheckoutStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PromoteToCheckoutStateQuery, PromoteToCheckoutStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PromoteToCheckoutStateQuery, PromoteToCheckoutStateQueryVariables>(PromoteToCheckoutStateDocument, options);
        }
export type PromoteToCheckoutStateQueryHookResult = ReturnType<typeof usePromoteToCheckoutStateQuery>;
export type PromoteToCheckoutStateLazyQueryHookResult = ReturnType<typeof usePromoteToCheckoutStateLazyQuery>;
export type PromoteToCheckoutStateSuspenseQueryHookResult = ReturnType<typeof usePromoteToCheckoutStateSuspenseQuery>;
export type PromoteToCheckoutStateQueryResult = ApolloReactCommon.QueryResult<PromoteToCheckoutStateQuery, PromoteToCheckoutStateQueryVariables>;
export const PromoteToCheckout_PromoteDocument = gql`
    mutation PromoteToCheckout_Promote($input: PromoteToCheckoutInput!) {
  promoteToCheckout(input: $input) {
    emptyResult
  }
}
    `;

/**
 * __usePromoteToCheckout_PromoteMutation__
 *
 * To run a mutation, you first call `usePromoteToCheckout_PromoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteToCheckout_PromoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteToCheckoutPromoteMutation, { data, loading, error }] = usePromoteToCheckout_PromoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePromoteToCheckout_PromoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PromoteToCheckout_PromoteMutation, PromoteToCheckout_PromoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PromoteToCheckout_PromoteMutation, PromoteToCheckout_PromoteMutationVariables>(PromoteToCheckout_PromoteDocument, options);
      }
export type PromoteToCheckout_PromoteMutationHookResult = ReturnType<typeof usePromoteToCheckout_PromoteMutation>;
export type PromoteToCheckout_PromoteMutationResult = ApolloReactCommon.MutationResult<PromoteToCheckout_PromoteMutation>;
export const PromoteToCheckout_RestoreDocument = gql`
    mutation PromoteToCheckout_Restore($input: SaveProductOfferingInput!) {
  saveProductOffering(input: $input) {
    productOffering {
      id
    }
  }
}
    `;

/**
 * __usePromoteToCheckout_RestoreMutation__
 *
 * To run a mutation, you first call `usePromoteToCheckout_RestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteToCheckout_RestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteToCheckoutRestoreMutation, { data, loading, error }] = usePromoteToCheckout_RestoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePromoteToCheckout_RestoreMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PromoteToCheckout_RestoreMutation, PromoteToCheckout_RestoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PromoteToCheckout_RestoreMutation, PromoteToCheckout_RestoreMutationVariables>(PromoteToCheckout_RestoreDocument, options);
      }
export type PromoteToCheckout_RestoreMutationHookResult = ReturnType<typeof usePromoteToCheckout_RestoreMutation>;
export type PromoteToCheckout_RestoreMutationResult = ApolloReactCommon.MutationResult<PromoteToCheckout_RestoreMutation>;